module.exports = __webpack_public_path__ + "img/Realisme_Naturalismen_Garborg.90f8c0ad.jpg";